<a class="link" href="https://www.quebec.ca/gouvernement/ministere/securite-publique" target="_blank">
    <img src="assets/images/MSP.svg" alt="Minitère de la Sécurité publique" width="157.5" height="42.32">
</a>

<a class="link" href="https://www.quebec.ca/droit-auteur" target="_blank">© Gouvernement du Québec, 2023</a>